import React, {use, useEffect, useState} from 'react';
import { connect } from 'react-redux';
import LogoSvg from '../svg/Logo.js';
import { useCookies } from 'react-cookie';
import {cookies_string} from '../config.js';
import { Login } from '../actions/actions.js';
import { useNavigate, useLocation } from 'react-router-dom';
import { fetchUserDataById } from '../services2/users.service.js';

function Component(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const [ __, _, removeCookie] = useCookies([`${cookies_string}_cred`,`${cookies_string}_token`]);
    const [isShowMenu,setisShowMenu]=useState(false)
	const handleLogout=()=>{
		props.dispatch(Login(false))
        removeCookie(`${cookies_string}_token`,'/')
        removeCookie(`${cookies_string}_cred`,'/')   
	}
    const toggleMenu=()=>{setisShowMenu(!isShowMenu)}
    const handleRoute=(route)=>()=>{
        navigate(`/platform2/${route}`);
    }

    let [user,setuser]=useState(null)

    async function fetchData(){
        let result = await fetchUserDataById(props.token.token)
        if( result.result){
            setuser(result.result)
        }
    }
    useEffect(()=>{
        if(props.token.token)
            fetchData()
    },[props.token.token])

    const isMobile=window.innerWidth<1024;
    if(props.token.usertype==='student'&&location.pathname.split('/')[3]!==undefined&&location.pathname.split('/')[2]==='missions'){
        return(<div/>)
    }
    if(props.token.usertype==='p-student'&&location.pathname.split('/')[3]!==undefined&&location.pathname.split('/')[2]==='missions'){
        return(<div/>)
    }

    return(
        <div className='bg-[white] w-full flex flex-row justify-between items-center px-[16px] py-[24px]' style={{overflowX:'auto'}}>
            <div className='cursor-pointer' onClick={()=>{navigate('/')}}><LogoSvg width={isMobile?160:275}/></div>
            {/* <div className='menu_container_1'>
                <div className='menu_icon'/>
                <div className={(location.pathname.split('/')[2]==='words')||location.pathname.split('/')[2]===''?'menu_item_selected mousehover':'menu_item_unselected mousehover'} onClick={handleRoute('words')}>字卡表</div>
                <div className={location.pathname.split('/')[2]==='combinations'?'menu_item_selected mousehover':'menu_item_unselected mousehover'} onClick={handleRoute('combinations')}>文字合併</div>
                <div className={location.pathname.split('/')[2]==='books'?'menu_item_selected mousehover':'menu_item_unselected mousehover'} onClick={handleRoute('books')}>書</div>
            </div> */}
            {/* <div className='menu_container_1'>
                <div className='menu_username'>{props?.token?.username||'unknown user'}</div>
                <div className='menu_arrowbutton mousehover' onClick={toggleMenu}><DownArrow/></div>
                <div className='menu_logout_button mousehover' onClick={handleLogout}>登出</div>
                <div className='menu_setting'>
                    <div className='menu_setting_item mousehover' onClick={handleRoute('changepassword')}>更改密碼</div>
                    <div className='menu_setting_item mousehover' onClick={handleRoute('manage')}>帳號管理</div>
                </div>
            </div> */}
            <div className='flex flex-row items-center' style={{gap:isMobile?'8px':'24px',fontSize:isMobile?'12px':'16px'}}>
                <div>{user?.name?`姓名: ${user?.name}`:props.token?.username}</div>
                <div>{user?.class?`班級: ${user?.class}`:''}</div>
                <div className='cursor-pointer text-[blue]' onClick={handleLogout}>登出</div>
            </div>
        </div>
    )
}
export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)